var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13399 9.55855L8.23632 3.45621C8.3526 3.33994 8.51029 3.2746 8.67473 3.2746C8.83916 3.2746 8.99686 3.33994 9.11313 3.45621L15.2155 9.55855C15.4499 9.79297 15.7678 9.92468 16.0993 9.92468C16.4308 9.92468 16.7488 9.79297 16.9832 9.55855C17.2177 9.32413 17.3494 9.00616 17.3494 8.67464C17.3494 8.34312 17.2177 8.0252 16.9832 7.79078L9.55861 0.36616C9.32419 0.131739 9.00627 2.59735e-05 8.67475 2.59445e-05C8.34323 2.59155e-05 8.02526 0.131739 7.79084 0.36616L0.366223 7.79078C0.131802 8.0252 8.78763e-05 8.34316 8.78473e-05 8.67469C8.78183e-05 9.00621 0.131802 9.32413 0.366222 9.55855C0.600643 9.79297 0.918564 9.92468 1.25008 9.92468C1.5816 9.92468 1.89957 9.79297 2.13399 9.55855Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbove);
export default __webpack_public_path__ + "static/media/Above.e013485f93bf098f836ed45ab4544516.svg";
export { ForwardRef as ReactComponent };